class HttpError extends Error {
    statusCode;
    constructor(statusCode, message) {
        super(message);
        this.statusCode = statusCode;
        Object.setPrototypeOf(this, HttpError.prototype);
    }
}
class JsonError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, JsonError.prototype);
    }
}
const fetchProvider = (token, appName, shopRoute, requestTimeout) => {
    const customFetch = async (url, acceptedCodes, init) => {
        const bffUrl = (shopRoute) + url;
        const headers = token
            ? {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-Caller': appName,
                    Authorization: `Bearer ${token}`,
                },
            }
            : {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-Caller': appName,
                },
            };
        const response = await fetch(bffUrl, {
            ...init,
            ...headers,
        });
        if (!response.ok || (acceptedCodes && !acceptedCodes.includes(response.status))) {
            throw new HttpError(response.status, await response.text());
        }
        try {
            let responseText = await response.text();
            if (responseText === '') {
                responseText = '{}';
            }
            const returnedValue = {
                statusCode: response.status,
                responseBody: JSON.parse(responseText),
            };
            return Promise.resolve(returnedValue);
        }
        catch (e) {
            if (e instanceof Error) {
                throw new JsonError(e.message);
            }
            else {
                throw new JsonError(e);
            }
        }
    };
    //add some convenience methods
    customFetch.get = async (url, acceptedCodes, init = { method: 'GET' }) => customFetch(url, acceptedCodes, init);
    customFetch.delete = async (url, acceptedCodes, init = { method: 'DELETE' }) => customFetch(url, acceptedCodes, init);
    customFetch.post = async (url, body, acceptedCodes, init = {
        method: 'POST',
        body: JSON.stringify(body),
    }) => customFetch(url, acceptedCodes, init);
    customFetch.put = async (url, body, acceptedCodes, init = {
        method: 'PUT',
        body: JSON.stringify(body),
    }) => customFetch(url, acceptedCodes, init);
    customFetch.patch = async (url, body, acceptedCodes, init = {
        method: 'PATCH',
        body: JSON.stringify(body),
    }) => customFetch(url, acceptedCodes, init);
    return customFetch;
};

export { HttpError, JsonError, fetchProvider };
//# sourceMappingURL=fetch.js.map
